// extracted by mini-css-extract-plugin
export default {"BooleanFeature":"vu_a bhk_b"};